import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ae01a3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "title" }, "メタデータ", -1))
const _hoisted_3 = { class: "table matadata" }
const _hoisted_4 = {
  key: 0,
  "data-cy": "field-metadata"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("table", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.metadata, (data, index) => {
        return (_openBlock(), _createElementBlock("tbody", { key: index }, [
          (data.sortNo)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [
                _createElementVNode("th", null, _toDisplayString(data.screenItemName), 1),
                _createElementVNode("td", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formatMetadataValue(data.value, data.id), (inputValue, index) => {
                    return (_openBlock(), _createElementBlock("p", {
                      class: "text-metadata",
                      key: index
                    }, _toDisplayString(_ctx.convertPermission(inputValue, data.id)), 1))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}